export const createInfoSlice = (set) => ({
  makes: [],  // => id, name 
  models: [],  // => id, name, make_id 
  colors: [],  // => id, name 
  years: [],  // => id, year 
  setMakes: (makes) => set(() => ({ makes: makes })),
  setModels: (models) => set(() => ({ models: models })),
  setColors: (colors) => set(() => ({ colors: colors })),
  setYears: (years) => set(() => ({ years: years })),
})